import { tokenSelector } from 'modules/auth/selectors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import forbidden_img from 'resources/images/forbidden_img.svg';
import { useAppSelector } from 'utils/customHooks';

function NotFound() {
  const { t } = useTranslation();

  const token = useAppSelector(tokenSelector);
  const location = useLocation() as any;
  const { pathname, search } = location;

  if (!token) {
    // URL直リクエスト時に、未ログインだった場合、ログインURLにリダイレクトURLパラメータを設定する
    const redirectPath = pathname === '/' ? '/login' : `/login?redirectPath=${encodeURIComponent(pathname + search)}`;
    return <Redirect to={redirectPath} />;
  }
  return (
    <div className="authority">
      <img src={forbidden_img} alt="forbidden_img" />
      {t('message.common.0004')}
    </div>
  );
}

export default NotFound;
